export default __webpack_public_path__ + "static/media/two-steps-verification-illustration-dark.b1796a7d.svg";